import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { appendQueryString } from 'Utils';
import Nav from 'Components/profile/Nav';

const RouterNav = ({
  alignment,
  onClick,
  location,
  parentRoute,
  routes,
  strings,
}) => {
  const tabs = routes.map((route) => {
    const href = appendQueryString(
      `${parentRoute.url}${parentRoute.nestedRoutes[route.key].url}`,
      window.location.search
    );
    return {
      ...route,
      href,
    };
  });

  return (
    <Nav
      activeTab={location.pathname}
      alignment={alignment}
      onClick={onClick}
      tabs={tabs}
      strings={strings}
    />
  );
};

RouterNav.propTypes = {
  alignment: PropTypes.oneOf(['vertical', 'horizontal']),
  onClick: PropTypes.func,
  parentRoute: PropTypes.object.isRequired,
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      key: PropTypes.string.isRequired,
    })
  ).isRequired,
  strings: PropTypes.object.isRequired,
};

RouterNav.defaultProps = {
  alignment: 'vertical',
  onClick: () => {},
};

export default withRouter(RouterNav);
